import * as amplitude from '@amplitude/analytics-browser';
import {
  API_GATEWAY_URI,
  NEXT_PUBLIC_AMPLITUDE_API_KEY,
} from '@config/environment';
import { Console } from '@utils/logger';

export const initializeAmplitude = () => {
  if (!NEXT_PUBLIC_AMPLITUDE_API_KEY) {
    Console.warn(
      '[AMPLITUDE]: Amplitude API key not found. Analytics tracking disabled.',
    );
    return;
  }
  try {
    amplitude.init(NEXT_PUBLIC_AMPLITUDE_API_KEY, {
      serverUrl: API_GATEWAY_URI ? `${API_GATEWAY_URI}/analytics` : undefined,
      autocapture: {
        attribution: true,
        sessions: true,
        formInteractions: true,
        fileDownloads: true,
        elementInteractions: true,
        networkTracking: true,
      },
    });

    Console.log('[AMPLITUDE]: Amplitude initialized successfully');
  } catch (error) {
    Console.error('[AMPLITUDE]: Failed to initialize Amplitude:', error);
  }
};

export const identifyUser = (
  userId: string,
  userProperties?: Record<string, any>,
) => {
  try {
    if (userProperties) {
      const identify = new amplitude.Identify();
      Object.entries(userProperties).forEach(([key, value]) => {
        identify.set(key, value);
      });
      amplitude.identify(identify);
    }

    amplitude.setUserId(userId);
    Console.log('[AMPLITUDE]: User identified in Amplitude:', userId);
  } catch (error) {
    Console.error('[AMPLITUDE]: Failed to identify user in Amplitude:', error);
  }
};

export const trackEvent = (
  eventName: string,
  eventProperties?: Record<string, any>,
) => {
  try {
    amplitude.track(eventName, eventProperties);
  } catch (error) {
    Console.error('[AMPLITUDE]: Failed to track event in Amplitude:', error);
  }
};

export const resetAmplitude = () => {
  try {
    amplitude.reset();
    Console.log('[AMPLITUDE]: Amplitude user data reset');
  } catch (error) {
    Console.error('[AMPLITUDE]: Failed to reset Amplitude:', error);
  }
};

export const getAmplitudeInstance = () => amplitude;

export default amplitude;
